import type { Moment } from 'moment'
import { rem } from 'polished'
import React from 'react'
import styled from 'styled-components'

import LocationWithMap from './LocationWithMap'
import SummaryDateTime from './SummaryDateTime'

import Heading from 'LuxKit/Typography/Heading'
import type { Place } from 'tripPlanner/types/common'

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${rem(20)};
  width: 100%;
`

type Props = {
  place: Place
  date: Moment | undefined
  time: Moment | undefined
  placeLabel: string
  day?: number
}

function LocationAndDateTime({ place, placeLabel, date, time, day }: Props) {
  return (
    <Wrapper>
      <Heading variant="heading6">{placeLabel}</Heading>
      <LocationWithMap place={place} />
      <SummaryDateTime date={date} time={time} day={day} />
    </Wrapper>
  )
}

export default LocationAndDateTime
